export const CONTACT = {
  email: "survey@geodrafting.com",
  whatsapp: [
    { region: "IN", label: "+91 80836 91588", wa: "918083691588" },
    { region: "US", label: "+1 262 739 8208", wa: "12627398208" },
  ],
  locations: [
    { country: "India", lines: ["Sanskruti Apartment, Basement,", "11th Ln, Laxmi Nagar, Jaysingpur,", "Maharashtra, India 416101"] },
    { country: "USA", lines: ["2424 W Brandon Blvd,", "Brandon, FL 33511, USA"] },
  ],
  serving: "Serving USA (Northern States), Canada, Australia & the UK",
  hours: [
    { days: "Mon – Fri", time: "8:00 AM – 6:00 PM EST" },
    { days: "Sat", time: "9:00 AM – 2:00 PM EST" },
  ],
};

export const waHref = (n) => `https://wa.me/${n.wa}`;
